import axios from 'axios';
import { INBOX_API_BASE_URL } from './config';

const API_BASE =
  (INBOX_API_BASE_URL || 'http://localhost:5000').replace(/\/+$/, '');

const inboxApi = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  // IMPORTANT:
  // On désactive l'envoi des credentials/cookies pour éviter le blocage CORS
  // quand le backend renvoie `Access-Control-Allow-Origin: *`.
  // (Ce module "inbox" ne doit pas dépendre du cookie auth.)
  withCredentials: false,
});

function getErrorMessage(err) {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.response?.data?.status ||
    err?.message ||
    'Erreur inconnue'
  );
}

export async function fetchBrands() {
  try {
    const resp = await inboxApi.get('/api/brands');
    return resp.data?.brands || [];
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function fetchConversations({ channel, brand, limit }) {
  try {
    const params = new URLSearchParams();
    if (channel) params.set('channel', channel);
    if (brand) params.set('brand', brand);
    if (limit) params.set('limit', String(limit));

    const query = params.toString();
    const url = query ? `/api/inbox/conversations?${query}` : '/api/inbox/conversations';
    const resp = await inboxApi.get(url);
    return resp.data?.conversations || [];
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function fetchConversationMessages({ conversationId, limit }) {
  try {
    const params = new URLSearchParams();
    if (limit) params.set('limit', String(limit));

    const query = params.toString();
    const url = query
      ? `/api/inbox/conversations/${encodeURIComponent(conversationId)}/messages?${query}`
      : `/api/inbox/conversations/${encodeURIComponent(conversationId)}/messages`;

    const resp = await inboxApi.get(url);
    return resp.data?.messages || [];
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function markConversationAsRead(conversationId) {
  try {
    const resp = await inboxApi.post(
      `/api/inbox/conversations/${encodeURIComponent(conversationId)}/read`,
      {}
    );
    return resp.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function sendOutboundMessage({
  channel,
  brand,
  userId,
  message,
  imageUrl,
  fileUrl,
  fileName,
  templateName,
  templateLanguage,
  templateComponents,
}) {
  try {
    const payload = {
      channel,
      brand,
      userId,
      message,
    };
    if (imageUrl) payload.imageUrl = imageUrl;
    if (fileUrl) payload.fileUrl = fileUrl;
    if (fileName) payload.fileName = fileName;
    if (templateName) payload.templateName = templateName;
    if (templateLanguage) payload.templateLanguage = templateLanguage;
    if (templateComponents) payload.templateComponents = templateComponents;

    const resp = await inboxApi.post('/api/inbox/reply', payload);
    return resp.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function uploadConversationMedia(file) {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const resp = await inboxApi.post('/api/inbox/upload-media', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return resp.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

export async function fetchWhatsappTemplates({ brand }) {
  try {
    const params = new URLSearchParams();
    if (brand) params.set('brand', brand);
    const query = params.toString();
    const url = query
      ? `/api/inbox/whatsapp/templates?${query}`
      : '/api/inbox/whatsapp/templates';
    const resp = await inboxApi.get(url);
    return resp.data?.templates || [];
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
}

